import { FormValues } from "rivals/components/pages/Registration/CreateAccount/types";
import { FormValues as GiftingFormValues } from "rivals/components/pages/Registration/Gifts/Purchase/types";

const MIN_PASSWORD_LENGTH = 9;

// This is the JavaScript equivalent of the email validation regex used in backend/app/models/user.rb
const VALID_EMAIL_REGEX = /^[A-Za-z0-9_%+-](?:\.?[A-Za-z0-9_%+-]+)*@[A-Za-z0-9-](?:\.?[A-Za-z0-9-]+)*\.[A-Za-z]+$/;
const VALID_NAME_REGEX = /^[A-Za-z\s-.]+$/;
const VALID_PASSWORD_REGEX = /\d/;

export function isValidEmail(email: string): boolean {
  return VALID_EMAIL_REGEX.test(email);
}

export function isValidName(value: string): boolean {
  return VALID_NAME_REGEX.test(value);
}

export function isValidPassword(password: string): boolean {
  return (
    password.length >= MIN_PASSWORD_LENGTH &&
    VALID_PASSWORD_REGEX.test(password)
  );
}

function emptyString(inputValue: string): boolean {
  return inputValue != "";
}

export function validateUserFormInput(
  inputValues: string[],
  error?: boolean
): boolean {
  return error ? inputValues.some(emptyString) : inputValues.every(emptyString);
}

export function invalidUserInput(formValues: FormValues): boolean {
  const filledInputs = validateUserFormInput([
    formValues.password,
    formValues.email,
    formValues.username
  ]);

  const inputError = validateUserFormInput(
    [
      formValues.errors.email,
      formValues.errors.password,
      formValues.errors.username
    ],
    true
  );

  return !filledInputs || inputError;
}

export function invalidGiftingInput(formValues: GiftingFormValues): boolean {
  const filledInputs = validateUserFormInput([
    formValues.recipientName,
    formValues.recipientEmail,
    formValues.gifterEmail,
    formValues.gifterName
  ]);

  const inputError = validateUserFormInput(
    [formValues.errors.recipientEmail, formValues.errors.gifterEmail],
    true
  );

  return !filledInputs || inputError;
}

export function isValidDate(dateStr: string | number): boolean {
  return !isNaN(new Date(dateStr).valueOf());
}
